// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../linguando/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../linguando/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".grecaptcha-badge {\n    visibility: hidden;\n    opacity: 0;\n}\n", "",{"version":3,"sources":["webpack://./../workspaces/packages/recaptcha/src/styles/googleRecaptchaV3.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,UAAU;AACd","sourcesContent":[".grecaptcha-badge {\n    visibility: hidden;\n    opacity: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
